export default __webpack_public_path__ + "static/media/seishuuun.555701ef.jpeg";